import React from 'react';
import { Box } from '@mui/material';
import { colors } from '../constants';
import { marginColor } from '../lib/format';

/** Gross margin bar: green at 60%+, amber at 40%+, red below. */
export function MarginBar({ value }) {
  const width = Math.min(100, Math.max(0, value));
  return (
    <Box
      sx={{
        height: 6,
        backgroundColor: colors.muted,
        borderRadius: 999,
        overflow: 'hidden',
        mt: 0.5,
      }}
    >
      <Box
        sx={{
          height: '100%',
          borderRadius: 999,
          width: `${width}%`,
          backgroundColor: marginColor(value),
        }}
      />
    </Box>
  );
}

/** Plain proportional bar in an arbitrary color, used for shares and costs. */
export function ShareBar({ width, color = colors.primary, height = 6, sx }) {
  return (
    <Box
      sx={{
        height,
        backgroundColor: colors.muted,
        borderRadius: 999,
        overflow: 'hidden',
        ...sx,
      }}
    >
      <Box
        sx={{
          height: '100%',
          borderRadius: 999,
          width: `${Math.min(100, Math.max(0, width))}%`,
          backgroundColor: color,
        }}
      />
    </Box>
  );
}

/** The colored dot that identifies a channel in lists and tables. */
export function ChannelDot({ color, size = 10 }) {
  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: color,
        flexShrink: 0,
      }}
    />
  );
}
